import React, { lazy, Suspense, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faHandshake, faPersonCirclePlus } from '@fortawesome/free-solid-svg-icons';
import SEOHelmet from '../Component/SEOHelmet';
import Step from '../Component/Home/4step';

const Header = lazy(() => import('../Component/Header'));
const About = lazy(() => import('../Component/Home/About'));
const Footer = lazy(() => import('../Component/Footer'));

const AboutUs = () => {

    const [isScrollTopVisible, setIsScrollTopVisible] = useState(false);
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const [data, setData] = useState(null);

    const handleClick = () => {
        window.location.href = '/hiring';
    };

    useEffect(() => {
        const storedData = sessionStorage.getItem('hiringStatus');
        if (storedData) {
            setData(JSON.parse(storedData)); // Parse the JSON string
        }
    }, []);


    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setIsScrollTopVisible(true);
            } else {
                setIsScrollTopVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <SEOHelmet
                title="About Us | Plexus Technology"
                description="Learn more about our innovative IT solutions, software development, and IT consulting services."
                keywords="Tech Experts , Innovative Solutions , Tech Team , Business Solutions , Work Culture , Employee Development , Career Growth , Tech Talent , Plexus Mission , Future Technology , Business Transformation , Global IT Services , About Plexus Technology , Tech Company Overview , Technology Experts at Plexus , Innovative Technology Solutions , IT Solutions Provider , Plexus Technology Team , Tech Solutions for Businesses , Life at Plexus Technology , Employee Culture at Plexus , Work at Plexus Technology , Innovative Work Culture , Career Growth at Plexus , Employee Development Programs , Employee Success at Plexus , Tech Talent at Plexus , Plexus Technology Mission , Future of Technology , Shaping the Future with Technology , Transforming Businesses through Technology , Global IT Services Leader"
                ogTitle="About Us | Plexus Technology"
                ogDescription="Discover how Plexus Technology delivers top-notch IT services to businesses globally."
                ogImage="https://plexus-technology.in/static/media/logo.589291ad7a3760919228.png"
                twitterCard="summary_large_image"
            />

            <Suspense>
                <Header />
                <About />
                <Step />
                <Footer />
            </Suspense>

            <>
                <div className="fixed-button d-flex">
                    <div className="w-auto mx-auto d-flex gap-3 flex-wrap align-items-center justify-content-center">
                        {data === "true" && (
                            <button
                                className="button1"
                                onClick={handleClick}
                            >
                                <FontAwesomeIcon icon={faPersonCirclePlus} className="me-2" />
                                We're Hiring
                            </button>
                        )}

                        <a
                            href="/portfolio"
                            className="button2 text-decoration-none"
                        >
                            <FontAwesomeIcon icon={faHandshake} className="me-2" />
                            Let’s Collaborate
                        </a>
                    </div>
                </div>
            </>

            {isScrollTopVisible && (
                <p className='fixed-top-btn cursor' onClick={scrollToTop}>
                    <FontAwesomeIcon icon={faArrowUp} className='px-2' />
                </p>
            )}
        </>
    );
};

export default AboutUs;